import { capybaraLevels } from "@/constants";

export const findLeagueConfig = (leagueName: string) => {
  return (
    capybaraLevels.find(
      (Level) => Level.leagueName.toLowerCase() === leagueName.toLowerCase()
    ) ?? null
  );
};
